import { type GetSmsChatQuery } from '@/generated/usermobile-bff/graphql';
import { formatDateOnly } from '@/formatters/formatDateOnly';

export type SmsChatMessage = GetSmsChatQuery['smsChat']['data'][number];

export interface SmsChatDateGroup {
  readonly date: string;
  readonly messages: readonly SmsChatMessage[];
}

// The chat reads oldest to newest like any messaging app, and the API makes no
// ordering promise, so the order is established here rather than assumed.
export const sortMessagesBySentAt = (
  messages: readonly SmsChatMessage[],
): readonly SmsChatMessage[] =>
  [...messages].sort((left, right) => Date.parse(left.sentAt) - Date.parse(right.sentAt));

export const groupMessagesByDate = (
  messages: readonly SmsChatMessage[],
): readonly SmsChatDateGroup[] => {
  const groups: SmsChatDateGroup[] = [];

  for (const message of messages) {
    const date = formatDateOnly(message.sentAt);
    const lastGroup = groups[groups.length - 1];

    if (lastGroup?.date === date) {
      groups[groups.length - 1] = { date, messages: [...lastGroup.messages, message] };

      continue;
    }

    groups.push({ date, messages: [message] });
  }

  return groups;
};
